import { View } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { useTheme } from '@ui-kitten/components';

import EmptyData from '../../Components/EmptyData';
import constants from '../../Config/constants';
import routeList from '../../Routes/list';
import themeStyle from '../../Theme/styles';

import ResponsiveLayout from '../ScreenWrapper/ResponsiveLayout';

const PageNoResult = () => {
  const route = useRoute();
  const theme = useTheme();
  const isPreview = route?.name === routeList.RES_EVENT_DETAILS_PREVIEW;

  return (
    <ResponsiveLayout
      title={constants.isWeb ? '' : 'Go Back'}
      LeftComponent={
        <View style={[themeStyle.flex1, themeStyle.justifyContentCenter]}>
          <EmptyData type="filter" fill={theme['color-info-500']} />
        </View>
      }
      backgroundColor={null} // to remove safearea on the top
      rightComponentWidth={0}
      withFooter={!isPreview}
      withTitleAnimation={false}
    />
  );
};

export default PageNoResult;
